let load = require('./helpers/browser/esm-js-loader');
module.exports = Promise.all([load("aHG2I"), load("bJvam"), load("7LOur")]).then(() => parcelRequire('7w8EY'));